import { getCdnUrl } from "../../../lib/getCdnUrl";
import { ChainIcon } from "../../Icon";
import { ImageFixedAO } from "../../Image_fixed_aspect_ratio";

export const ModalItemDetails = ({
  item,
  collection,
  isGlobal = false,
}: {
  item?: any;
  collection?: any;
  isGlobal: boolean;
}) => {
  if (!item && !collection) return null;
  const metadata =
    typeof item?.metadata === "string"
      ? JSON.parse(item?.metadata)
      : item?.metadata;
  const isMoonpetsItem =
    !!item?.itemId &&
    !!metadata?.name &&
    metadata?.name?.indexOf("MoonPets") !== -1;
  const itemImage = isMoonpetsItem
    ? `https://moonpets.com/api/nftThumbnailimage/${item.itemId}`
    : item?.imageFtpPath || item?.metadata?.image;

  const chain = item?.chain || collection?.chain;
  const name =
    collection?.contractType && collection?.contractType === "ERC1155"
      ? `${item?.name} #${item?.itemId}`
      : item?.name || metadata?.name || collection?.name + " #" + item?.itemId;

  return (
    <div className="mb-2 flex">
      <div className="mt-2 mb-2 w-[30%]">
        {(itemImage || collection?.profilePhotoPath) && (
          <ImageFixedAO
            image={
              isMoonpetsItem && !isGlobal
                ? itemImage
                : getCdnUrl(
                    (!isGlobal ? itemImage : collection?.profilePhotoPath) ||
                      "",
                    100,
                    item?.updatedAt || collection?.updatedAt
                  )
            }
            bottomRounded
          />
        )}
      </div>
      <div className="w-full pt-4 pl-4 pb-4">
        <h1 className="font-bold">{!isGlobal ? name : collection?.name}</h1>
        {item?.collection?.collectionmetrics?.floorPrice ||
        collection?.collectionmetrics?.floorPrice ? (
          <p className="flex font-medium">
            Floor Price:
            <span className="ml-auto flex">
              {item?.collection?.collectionmetrics?.floorPrice ??
                collection?.collectionmetrics?.floorPrice}
              <div className="mt-1 ml-2">
                <ChainIcon
                  width={16}
                  name={chain}
                  tooltip={null}
                  type={"chain"}
                />
              </div>
            </span>
          </p>
        ) : null}
        {item?.collection?.collectionmetrics?.topGlobalBid ||
        collection?.collectionmetrics?.topGlobalBid ? (
          <p className="flex font-medium">
            Top Global Bid:
            <span className="ml-auto flex">
              {item?.collection?.collectionmetrics?.topGlobalBid ??
                collection?.collectionmetrics?.topGlobalBid}
              <div className="mt-1 ml-2">
                <ChainIcon
                  width={16}
                  name={chain}
                  tooltip={null}
                  type={"chain"}
                />
              </div>
            </span>
          </p>
        ) : null}
      </div>
    </div>
  );
};
